<template>
	<div class="app-image" v-on="$listeners" :title="title"><slot></slot></div>
</template>

<script>

export default {
	props: {
		src: String,
		fallback: String,
		title: String
	},

	watch: {
		src: {
			handler (val) {
				const img = document.createElement('img')
				img.src = val || this.fallback

				img.addEventListener('load', e => { this.$el.style = `background-image: url('${e.target.src}');` })

				img.addEventListener('error', () => {
					if (this.fallback) {
						this.$el.style = `background-image: url('${this.fallback}');`
					}
				})
			},

			immediate: true
		}
	}
}
</script>

<style lang="scss" scoped>
.app-image {
	display: inline-block;
	min-width: 12px;
	min-height: 12px;
	background-repeat: no-repeat;
	background-color: transparent;
	background-size: contain;
	background-position: center;
}
</style>
